module.exports = __webpack_public_path__ + "img/reports.478f23b2.svg";